"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _dicts = require("@package/dicts");

var _react = require("react");

function _default(shop) {
  return (0, _react.useMemo)(function () {
    if (!shop) {
      return [];
    }

    var availableAccounts = {};

    if (!!Object.keys(shop['accounts']).length) {
      for (var key in shop['accounts']) {
        if (shop['accounts'].hasOwnProperty(key)) {
          var account = shop['accounts'][key];

          if (account['available'] > 0) {
            availableAccounts[key] = account;
          }
        }
      }
    }

    var shopAccounts = Object.keys(availableAccounts);
    return _dicts.CURRENCY_NAMES.filter(function (item) {
      return shopAccounts.includes(item['id']);
    });
  }, [shop]);
}